<script lang="ts">
import {defineComponent, onMounted, type PropType, ref, watch} from "vue";
import {translation, useTranslationStore} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    message: {
      type: String as PropType<string>,
      default: () => translation(translationList.value.loading, 'Se incarcă...'),
    },
    showDialog: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const dialog = ref(props.showDialog);
    const translationStore = useTranslationStore();
    const translationList = ref<TranslationList>({});

    watch(() => props.showDialog, (newVal) => {
      dialog.value = newVal;
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
    });

    return {
      dialog,
      translationList,
      translation
    };
  },
});
</script>

<template>
  <v-dialog
      v-model="dialog"
      max-width="350"
      scroll-strategy="none"
      persistent
  >
    <v-list
        bg-color="primary"
        class="py-2"
        color="primary"
        elevation="12"
        rounded="lg"
    >
      <v-progress-linear
          :active="true"
          :indeterminate="true"
          color="secondary"
          height="6"
          absolute
          top
      ></v-progress-linear>
      <v-list-item>
        <template v-slot:title>
          {{ message}}
        </template>

        <template v-slot:prepend>
          <div class="pe-4 d-flex align-center">
            <NuxtImg
                sizes="26"
                src="/images/logo-icon-white.png"
                loading="lazy"
                alt="Xiga Logo"
            />
          </div>
        </template>
      </v-list-item>
    </v-list>
  </v-dialog>
</template>

<style scoped>

</style>
